export function normaliseConfidence(confidence)
{
    if (confidence == null || isNaN(confidence))
    {
        return 0;
    }

    if (confidence > 1)
    {
        return confidence / 100;
    }

    return confidence;
}